import * as types from '../constants/ActionTypes';
import api from '../../config/api.js';

export function agreeToTermsConditions(userId, router) {
	return (dispatch, getState) => {
		return api.get(`/users/${userId}/terms_conditions`)
			.then(d => {
				dispatch({
					type: types.SET_USER,
					user: d.data
				});

				return d.data;
			})
			.catch(e => {
				console.log('Error updating terms and conditions.', e)
			});
	};
};


// WEBPACK FOOTER //
// ./src/actions/termsConditions.js